

<div class="ibox-title">
    <button *ngIf="enableBack" class="btn btn-sm btn-primary " (click)="back()"
          matTooltip="Volver"
          matTooltipClass="tooltip-ibox">
      <i class="volver fa fa-reply"></i>
    </button>
    <button *ngIf="isHistory" class="btn btn-sm btn-primary " [disabled]="!Previous?.id || IsEditing || onlyNew" (click)="previous()"
          matTooltip="Anterior"
          matTooltipClass="tooltip-ibox">
      <i class="historial fa fa-caret-left"></i>
    </button>
    <button *ngIf="isHistory" class="btn btn-sm btn-primary " (click)="openDialog()" [disabled]="IsEditing || onlyNew"
          matTooltip="Período visualizado"
          matTooltipClass="tooltip-ibox">
      <i class="historial fa fa-history"></i> Desde {{DateInit|date:'dd/MM/yyyy'}} hasta {{DateEnd|date:'dd/MM/yyyy'}}
    </button>
    <button *ngIf="isHistory" class="btn btn-sm btn-primary " [disabled]="!Next?.id || IsEditing || onlyNew" (click)="next()" 
      matTooltip="Siguiente"
      matTooltipClass="tooltip-ibox">
      <i class="historial fa fa-caret-right"></i>
    </button>
    <button class="btn btn-sm btn-warning " (click)="edit($event)" *ngIf="!IsEditing && Permiso" [disabled]="onlyNew && isHistory"
          matTooltip="Editar"
          matTooltipClass="tooltip-ibox">
        <i class="fa fa-pencil"></i>
    </button>
    <button class="btn btn-sm btn-primary " (click)="save($event)" *ngIf="IsEditing && Permiso" [disabled]="Errors "
        matTooltip="Guardar"
        matTooltipClass="tooltip-ibox">
        <i class="fa fa-save"></i>
    </button>
    <button class="btn btn-sm btn-primary " (click)="cancel($event)" *ngIf="IsEditing"
        matTooltip="Cancelar"
        matTooltipClass="tooltip-ibox">
        <i class="fa fa-times"></i>
    </button>
    <button *ngIf="isHistory && Permiso && enableCut" class="btn btn-sm btn-primary " (click)="cut($event)" [disabled]="IsEditing || onlyNew"
      matTooltip="Cortar"
      matTooltipClass="tooltip-ibox">
      <i class="historial fa fa-cut"></i>
    </button>
    <button *ngIf="isHistory && Permiso" class="btn btn-sm btn-danger " (click)="delete($event)" [disabled]="IsEditing  || onlyNew"
      matTooltip="Eliminar"
      matTooltipClass="tooltip-ibox">
      <i class="historial fa fa-trash"></i>
    </button>
    <button *ngIf="isHistory && Permiso" class="btn btn-sm btn-primary  nuevoHistorico" [disabled]="IsEditing"
      (click)="new($event)"
      matTooltip="Nuevo"
      matTooltipClass="tooltip-ibox">
      <i class="historial fa fa-plus"></i>
    </button>
  
  <div class="ibox-tools" dropdown>  
  <!--  <a dropdownToggle>
      <i class="fa fa-wrench"></i>
    </a>
    <ul class="dropdown-menu dropdown-user" *dropdownMenu>
      <li><a href="#">Config option 1</a>
      </li>
      <li><a href="#">Config option 2</a>
      </li>
    </ul> -->
    <h5>    
      <span class="titulo">{{Title}}</span>
    </h5>
    <a class="btn btn-sm " (click)="collapse($event)">
      <i class="fa fa-chevron-up"></i>
    </a>
    <a class="btn btn-sm " (click)="close($event)" *ngIf="!HideClose">
      <i class="fa fa-times"></i>
    </a>
  </div>
  
</div>

<p-dialog header="Historial de modificaciones" [(visible)]="displayModal" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false">
    
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Desde</th>
          <th>Hasta</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor='let p of PeriodList; index as _index' (click)="changePeriod(_index)">
            <td>{{p.desde|date:'dd/MM/yyyy'}}</td>
            <td>{{p.hasta|date:'dd/MM/yyyy'}}</td>
        </tr>
      </tbody>
    </table>

    <ng-template pTemplate="footer">
        <p-button icon="pi pi-times" styleClass="p-button-sm" (click)="displayModal=false" label="Cancelar"></p-button>
    </ng-template>
</p-dialog>